export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";